export default {
  title: 'Clinic Management',
  tagline: 'Add clinic',
};
